import { Box, Text, Tooltip, Icon, VStack, HStack } from '@chakra-ui/react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import config from '@/config.json';
import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';

function TelephoneNumberFormatter({ value, operatorStatus, operatorMessage }) {
    const rawValue = value;
    const formattedValue =
        rawValue &&
        rawValue !== 'Not Allocated' &&
        rawValue !== 'Not Licensed' &&
        rawValue !== 'MS Calling Plan Assigned'
            ? `+${rawValue}`
            : rawValue;

    const operatorStatusTip =
        'Operator Status: ' + config.numbers.operatorStatusJSON[operatorStatus];
    const operatorMessageTip = 'Operator Message: ' + operatorMessage;

    const hasOperatorInfo = operatorStatus != null || operatorMessage;

    const content = (
        <CopyCellRenderer value={rawValue} valueFormatted={formattedValue} />
    );

    if (!hasOperatorInfo) return content;

    return (
        <Tooltip
            hasArrow
            portalProps={{ containerRef: undefined }}
            maxW="400px"
            width="auto"
            label={
                <Box display="flex" alignItems="left">
                    <VStack spacing="5px" align="start">
                        {operatorStatus != null && (
                            <HStack spacing={0} align="center">
                                <Icon
                                    as={IoMdInformationCircleOutline}
                                    marginRight="5px"
                                    color="white"
                                />
                                <Text textAlign="left">
                                    {operatorStatusTip}
                                </Text>
                            </HStack>
                        )}
                        {operatorMessage && (
                            <Text textAlign="left">{operatorMessageTip}</Text>
                        )}
                    </VStack>
                </Box>
            }>
            {content}
        </Tooltip>
    );
}

export { TelephoneNumberFormatter };
